import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';
import { OperationType } from 'src/app/shared/interfaces/operation-type.enum';

export const B3_WITHDRAWAL_TRANSFER_REASON =
  'Transferência de custódia para contraparte fora da B3.';

export function isB3WithdrawalTransferOperation(operation: CarbonOperation): boolean {
  return (
    operation.rawTypeCode === OperationType.WITHDRAW &&
    operation.retirementCode === 'T'
  );
}
